import React from 'react'
import { useParams } from 'react-router-dom'

import Splash from './Splash'
import Cover from './Cover'
import Roster from './Roster'
import Standings from './Standings'
import Timer from './Timer'
import Event from './Event'
import EventsPanel from "./EventsPanel";

const overlays = {
    splash: Splash,
    cover: Cover,
    roster: Roster,
    standings: Standings,
    timer: Timer,
    event: Event,
    events: EventsPanel
}

const Components = () => {
    const { component } = useParams()
    const Specified = overlays[component]
    return Specified ? <Specified /> : <div>Component not found</div>
}

export default Components
